import Header from '@/components/layout/Header';
import GlobalMeetingTab from '@/components/home/GlobalMeetingTab';

const Meetings = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="container py-6">
        <GlobalMeetingTab />
      </main>
    </div>
  );
};

export default Meetings;
